interface Props {
  confidence: number // 0..1
  showLabel?: boolean
}

/** Confidence badge — pack colors: green ≥.85, gold .65-.85, orange .40-.65, red <.40. */
export function ConfidenceChip({ confidence, showLabel = true }: Props) {
  const pct = Math.round(confidence * 100)
  let color: string
  let label: string
  if (confidence >= 0.85) {
    color = '#8AB89F'
    label = 'high'
  } else if (confidence >= 0.65) {
    color = '#D9AC5C'
    label = 'medium'
  } else if (confidence >= 0.4) {
    color = '#E8A87C'
    label = 'low'
  } else {
    color = '#E06F5E'
    label = 'very low'
  }
  return (
    <span
      className="inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-tag font-mono uppercase"
      style={{ background: color + '22', color }}
    >
      <span
        aria-hidden
        className="inline-block h-1.5 w-1.5 rounded-full"
        style={{ background: color }}
      />
      {pct}%{showLabel && ` · ${label}`}
    </span>
  )
}
